import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {catchError, exhaustMap, map, of} from "rxjs";
import {auditActions} from "../actions"
import {inject, Injectable} from "@angular/core";
import {PaginatedResultModel} from "@core/model/paginated-result.model";
import {RoleModel} from "@core/model/aux/role.model";
import {SecurityService} from "@core/service/security-service";
import {AuditLog} from "@core/model/audit-log";
import {AUDIT_OPERATIONS} from "@core/consts/auth.constants";

@Injectable()
export class AuditEffects {
  private securityService: SecurityService = inject(SecurityService);

  constructor(
    private actions$: Actions,
    private readonly store: Store
  ) {
  }

  loadAdits = createEffect(() =>
    this.actions$.pipe(
      ofType(auditActions.loadAudits),
      exhaustMap(action => this.securityService.getAudits(action.params).pipe(
        map(response => {
          return auditActions.loadAuditsSuccess({
            response: response
          });
        }),
        catchError((error: any) => of(auditActions.loadRolesError({msg: error.error})))
      ))
    )
  );

}
